const firebaseConfig = {
    apiKey: "AIzaSyAHAUXdF6WuubMqhjXIpCxe-63VdBxUkVI",
    authDomain: "crypto-stalker-4f46e.firebaseapp.com",
    projectId: "crypto-stalker-4f46e",
    storageBucket: "crypto-stalker-4f46e.appspot.com",
    messagingSenderId: "203410953362",
    appId: "1:203410953362:web:54389f555177a98531024b"
  };

  export default firebaseConfig;